export const createStyles = () => ({
  list: {
    mt: '1rem',
    mx: '0.25rem',
    overflowY: 'auto',
    maxHeight: { xs: '88px', sm: '120px' },
  },
  listItemRoot: {
    py: '0.5rem',
  },
});
